import React from "react"
import useIsMobile from "@/shared/use_is_mobile"
import VenueHeaderDesktop from "./desktop"
import VenueHeaderMobile from "./mobile"
import type { VenueHeaderProps } from "./types"

const VenueHeader: React.FC<VenueHeaderProps> = (props) => {
  const isMobile = useIsMobile()
  return isMobile ? <VenueHeaderMobile {...props} /> : <VenueHeaderDesktop {...props} />
}

export default VenueHeader
